export default "__VITE_ASSET__B_QQ8JKS__"